import { z } from "zod";
import "../zod-runtime.js";
import { memberRoleSchema } from "../domain/enums.js";
export const sessionSchema = z.object({
    authenticated: z.boolean(),
    user: z
        .object({
        id: z.string().uuid(),
        email: z.string().email(),
        role: memberRoleSchema,
    })
        .nullable(),
    csrfToken: z.string().nullable(),
});
export const memberSchema = z.object({
    userId: z.string().uuid(),
    email: z.string().email(),
    role: memberRoleSchema,
    active: z.boolean(),
});
export const loginRequestSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(256),
});
/** Nachweise aus einem GoTrue-Mail-Link, Redirect oder manuell eingegebenen Code. */
export const passwordResetProofSchema = z.union([
    z.object({ accessToken: z.string().min(1) }),
    z.object({
        tokenHash: z.string().min(1),
        type: z.enum(["recovery", "invite"]),
    }),
    z.object({ email: z.string().email(), code: z.string().regex(/^\d{6}$/) }),
]);
export const passwordResetConfirmationSchema = passwordResetProofSchema.and(z.object({ password: z.string().min(12).max(256) }));
